/**
 * @generated SignedSource<<fefa6b9c3043cf80dda02fa150631c84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopNav_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopFilters_viewer" | "SbRespRefineMenuDrawer_viewer">;
  readonly " $fragmentType": "SbRespRefineTopNav_viewer";
};
export type SbRespRefineTopNav_viewer$key = {
  readonly " $data"?: SbRespRefineTopNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopFilters_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "93f7016f5253400531866e891b2370fd";

export default node;
